import { render, staticRenderFns } from "./LocationView.vue?vue&type=template&id=a9890502&lang=pug"
import script from "./LocationView.vue?vue&type=script&lang=ts"
export * from "./LocationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports